"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Translations = void 0;
var _i18n = require("@ori/i18n");
var _react = require("react");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file -- No need to test containers for translations

const Translations = ({
  translations = _constants.defaultTranslations,
  children,
  withTranslationsProvider = true
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const mergedTranslations = (0, _react.useMemo)(() => ({
    ..._constants.defaultTranslations,
    ...translations
  }), [translations]);
  if (!withTranslationsProvider) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
      namespace: _constants.translationsNamespace,
      children: children
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
    defaultTranslationsWithNamespaces: {
      [_constants.translationsNamespace]: _constants.defaultTranslations
    },
    language: language || 'en-GB',
    translationsWithNamespaces: {
      [_constants.translationsNamespace]: mergedTranslations
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
      namespace: _constants.translationsNamespace,
      children: children
    })
  });
};
exports.Translations = Translations;
//# sourceMappingURL=Translations.js.map